import { Container, Typography, Paper, Button } from '@mui/material'
import styled from 'styled-components/macro'
import { useNavigate } from 'react-router-dom'
import BlockIcon from '@mui/icons-material/Block'
import RouteContainer from 'src/components/App/RouteContainer'

const StyledPaper = styled(Paper)`
    padding: ${({ theme }) => theme.spacing(4)};
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing(4)};
`

const StyledIcon = styled(BlockIcon)`
    font-size: 64px;
    color: ${({ theme }) => theme.palette.error.main};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
`

const StyledButton = styled(Button)`
    margin-top: ${({ theme }) => theme.spacing(2)};
`

export function PermissionDeniedRoute() {
    const navigate = useNavigate()

    return (
        <RouteContainer>
            <Container maxWidth="sm">
                <StyledPaper elevation={3}>
                    <StyledIcon />
                    <Typography variant="h4" gutterBottom>
                        Zugriff verweigert
                    </Typography>
                    <Typography variant="body1" color="textSecondary" paragraph>
                        Sie haben keine Berechtigung, auf diese Ressource zuzugreifen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie glauben, dass dies ein Fehler ist.
                    </Typography>
                    <StyledButton
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/')}
                    >
                        Zurück zur Startseite
                    </StyledButton>
                </StyledPaper>
            </Container>
        </RouteContainer>
    )
} 